module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "4increasing-bar.615c73ce.svg";